import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import moment from 'moment';

import * as chatStatsActions from '../../actions/entities/ChatStatsActions';
import { Grid, GridHeader, GridBody, GridRow, GridCell } from '../../components/basic/grid';
import StatusChart from '../../components/chats/StatusChart';
import PlainTextField from '../../components/basic/PlainTextField';
import { getChatsFiltered } from "../../selectors/ChatsStatsSelector";

const getStatusChartProps = p => {
  const counts = R.path(['activity', 'statusCounts'], p) || {};
  return {
    totalCount: R.prop('total', counts) || 0,
    finishedCount: R.prop('finished', counts) || 0
  };
};

class ChatsStatsContainer extends React.Component {
  componentDidMount() {
    const { fetchChatsStats } = this.props;
    fetchChatsStats();
  }

  render() {
    const { companies, filter, setChatsFilter } = this.props;
    return (
      <div className="flex flex1">
        <Grid>
          <GridHeader>
            <GridRow className="row">
              <GridCell className="col-sm-12">
                <span>Chat</span>
              </GridCell>
            </GridRow>
            <GridRow className="row" style={{ padding: 0 }}>
              <GridCell className="col-sm-12" style={{ padding: 0 }}>
                <PlainTextField
                  placeholder="Filter..."
                  value={filter}
                  onChange={e => setChatsFilter(e.target.value)}
                  label="Filter"
                />
              </GridCell>
            </GridRow>
          </GridHeader>
          <div>
            <GridBody>
              {R.map(
                c => (
                  <div key={c.id}>
                    <GridRow className="row group-header">
                      <GridCell className="col-sm-12">
                        {c.name}
                      </GridCell>
                    </GridRow>
                    {R.map(p => (
                      <Link key={p.id} to={`/data/chats/stats/${p.id}`}>
                        <GridRow className="rowr">
                          <GridCell className="col-sm-12">
                            <div style={{ paddingRight: 60, minHeight: 60 }}>
                              <span>{p.name || <em>Unnamed</em>}</span>
                              <br/>
                              <pre><small>{c.slug}/{p.slug}</small></pre>
                              <span>{moment(p.createdAt).format('L LT')}</span>
                            </div>
                            <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0 }}>
                              <StatusChart {...getStatusChartProps(p)} />
                            </div>
                          </GridCell>
                        </GridRow>
                      </Link>
                    ), R.sortWith([R.ascend(R.prop('name')), R.descend(R.prop('createdAt'))])(c.projects))}
                  </div>
                ),
                R.filter(c => c.projects && c.projects.length, companies)
              )}
            </GridBody>
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companies: getChatsFiltered(state),
  filter: state.entities.chatsStats.filter
});

export default connect(mapStateToProps, chatStatsActions)(ChatsStatsContainer);



// WEBPACK FOOTER //
// ./src/containers/private/ChatsStatsContainer.js